import React from 'react';
import HorecaLayout from './HorecaLayout';
import HorecaProductsBanner from './components/horeca/horecaproductbanner';
import HorecaProducts1 from './components/horeca/horecaproducts1';
import HorecaProducts2 from './components/horeca/horecaproducts2';
import HorecaProducts3 from './components/horeca/horecaproducts3';
import HorecaProducts4 from './components/horeca/horecaproducts4';



const HorecaProduct = () => {

    return(
        <HorecaLayout>
        <HorecaProductsBanner/>
        <HorecaProducts1/>
        <HorecaProducts2/>
        <HorecaProducts3/>
        <HorecaProducts4/>
        </HorecaLayout>
        
    );



}

export default HorecaProduct;



